module.exports = __webpack_public_path__ + "static/media/160316_PRESSCOFFE_3in1_14g.a89e6a75.jpg";